const uuid = require('uuid/v4');

export default class Transaction {

  branch = null;
  sha = null;
  ref = null;
  lastCommit = null;
  elapsedSteps = 0;

  mergedSha = null;

  /**
   *
   * @param repository
   * @param parentBranch
   */
  constructor(repository, parentBranch = 'master') {
    this.repository = repository;
    this.parentBranch = parentBranch;
  }

  /**
   *
   * @return {Promise<void>}
   * @private
   */
  async _prepareBranch() {
    const branchName = `trxn-${uuid()}`;
    const response = await this.repository.createBranch(this.parentBranch, branchName);
    this.branch = branchName;
    this.ref = response.data.ref;
    this.sha = response.data.sha;
  }

  /**
   *
   * @param executor
   * @return {Promise}
   */
  async step(executor) {
    if (!this.branch) {
      await this._prepareBranch();
    }
    return await executor(this.branch, this.ref, this.sha, ++this.elapsedSteps);
  }

  /**
   *
   * @return {Promise}
   */
  async discard() {
    if (this.branch) {
      await this.repository.deleteRef(this.ref);
      this.branch = null;
      this.ref = null;
      this.sha = null;
    }
  }

  /**
   *
   * @return {Promise}
   */
  async commit() {
    const transactionPullRequest = await this.repository.createPullRequest({
      head: this.branch,
      base: this.parentBranch,
      title: `[Auto] Transaction: ${this.branch}`,
      maintainer_can_modify: false
    }).data;
    const baseSha = (await this.repository.getBranch(this.parentBranch)).commit.sha;
    this.mergedSha = (await this.repository.mergePullRequest(transactionPullRequest.id, {
      commit_title: `[Auto] Transaction: ${this.branch}`,
      merge_method: 'squash',
      sha: baseSha
    })).data.sha;
    await this.repository.deleteRef(this.ref);
  }

  /**
   *
   * @return {Promise}
   */
  async rollback() {
    // TODO To be implemented after GitHub API supports PR reverts.
    throw new Error(`GitHub API does not support reverting. Use GitHub UI or command line to revert. Merge commit SHA: ${this.mergedSha}.`);
  }
}
